// removed by extract-text-webpack-plugin
module.exports = {"overlay":"_2LA9xJvEiZnvRmlEJalPuX","active":"_1mb5R6Ke2XdDSlKyoBpyfY"};


//////////////////
// WEBPACK FOOTER
// ./~/react-toolbox/lib/overlay/theme.css
// module id = 1042
// module chunks = 0